
import { Box,  useMediaQuery,MenuItem, Select, Typography, Button } from '@mui/material';
import graphicon from "../../../assets/Dashboard/graphicon.svg";
import dashboardmap from "../../../assets/Dashboard/dashboardmap.png";
import CustomButton from '../../../components/CustomButton';
// import ClientAcquisitionTable from "./DashboardClients";
import PayoutsDonutChart from './PayoutChart';
import ActiveInactiveChart from './ActiveInactiveChart';
import chart1 from "../../../assets/chart1.svg";
import chart2 from "../../../assets/chart2.svg";
import maparrow from "../../../assets/maparrow.svg";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from 'react-router-dom';
import CustomText, { textStyles } from "../../../components/CustomText";
import back from "../../../assets/back.svg";
import {showUnderDevelopment} from '../../../components/alerts';
import MapCities from '../Dashboard/MapCities';
import ClientGrowthmap from '../Dashboard/ClientGrowthmap';
import RequestGraph from './RequestGraph';
import CompanyMarkersTable from '../Dashboard/PinsTable';
import DashboardPins from "../Dashboard/DashboardPins"
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';
import { useEffect } from 'react';

import { useState } from 'react';


const ReportsandStatistics = () => {

const { t } = useTranslation();

  const isMobile = useMediaQuery('(max-width:768px)');
    const [isExpanded, setIsExpanded] = useState(false);
  
    const location = useLocation();
const navigate = useNavigate();
const fromDashboard = location.state?.fromDashboard || false;
    useEffect(() => {
  if (location.hash) {
    const id = location.hash.replace('#', '');
    const element = document.getElementById(id);
    if (element) {
      // Delay to allow component rendering
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    }
  }
}, [location]);


  return (

  <Box sx={{ pl: isMobile ? 0.5 : 1.5, pr: isMobile ? 0.5 : 0, py: 1 }}>

    {fromDashboard && (
  <Box
    sx={{
      border: '1px solid #E4E6EF',
      borderRadius: 2,
      px: 2,
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      minHeight: 55,
      mb: 2
    }}
  >
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
      onClick={() => navigate(-1)}
    >
      <img src={back} style={{ width: 30, height: 30 }} />
      <CustomText
        sx={{
          ...textStyles.h1,
          fontWeight: 500,
          fontSize: '14px',
          color: '#626F86',
          textAlign: 'center'
        }}
      >
        {t('clientsTrialDetails.back')} 
      </CustomText>
    </Box>
  </Box>
)}

     <Box sx={{ mt: 2, width: '100%', overflowX: 'auto' }}>
 <DashboardPins/>

</Box>
{/* <MapCities/> */}


      <Box sx={{ mt: 4, display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' } }}>
<ClientGrowthmap/>

        
<RequestGraph/>
      </Box>

{/* <Box sx={{ mt: 2, width: '100%', overflowX: 'auto' }}>
  <ClientAcquisitionTable />
</Box> */}

<Box
  sx={{
    display: "flex",
    // flexDirection: { xs: "column", md: "row" ,lg:"row"}, // 🔁 Column on mobile, row on desktop
    // flexDirection:isMobile?"column":"row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 1,
    flexWrap: "wrap", // ✅ Ensures wrapping if width overflows
    mt: 2,
  }}
>

    {/* <Box id='earning-section' sx={{width:isMobile?"97%":"28%"}}>
    <PayoutsDonutChart />
  </Box> */}
    <Box 
    // sx={{width:isMobile?"97%":"71%"}}
        sx={{width:"100%"}}
    >
    <ActiveInactiveChart/>
  </Box>
</Box>
</Box>
  );
};

export default ReportsandStatistics;